var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgOmrIcon = function SvgOmrIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 43 13",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.878 0Q4.037 0 2.017 1.91 0 3.82 0 6.5q.001 2.686 2.017 4.59Q4.037 13 6.878 13q2.831 0 4.854-1.91c1.347-1.269 2.025-2.8 2.025-4.59 0-1.787-.678-3.317-2.025-4.59Q9.709 0 6.878 0m2.914 9.253q-1.216 1.14-2.914 1.14-1.71 0-2.913-1.14Q2.754 8.11 2.755 6.5q-.001-1.607 1.21-2.753 1.204-1.15 2.913-1.15 1.698 0 2.914 1.15c.812.763 1.213 1.683 1.213 2.753 0 1.074-.401 1.99-1.213 2.753M36.888 6.34 42.902.107H31.194V2.67h5.552l-3.81 3.67 6.127 6.546H43zM15.676.107v12.778h2.849V7.509l4.086 5.161 4.083-5.161v5.376h2.853V.107L22.61 8.184z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOmrIcon);
export default ForwardRef;